import Cookies from 'js-cookie';

interface UtmSource extends Record<string, string | undefined> {
  utm_source: string | undefined;
  utm_medium: string | undefined;
  utm_campaign: string | undefined;
  utm_id: string | undefined;
  utm_term: string | undefined;
  utm_content: string | undefined;
}

export function getUtmParams(): UtmSource {
  const utmParams: UtmSource = {
    utm_source: Cookies.get('gb_utm_source'),
    utm_medium: Cookies.get('gb_utm_medium'),
    utm_campaign: Cookies.get('gb_utm_campaign'),
    utm_id: Cookies.get('gb_utm_id'),
    utm_term: Cookies.get('gb_utm_term'),
    utm_content: Cookies.get('gb_utm_content'),
  };
  return utmParams;
}
